import { configureStore } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import advisorReducer from '@/redux/slices/advisorSlice'
import configurationReducer from '@/redux/slices/configurationSlice'
import chatReducer from '@/redux/slices/chatSlice'
import userReducer from '@/redux/slices/userSlice'
import roomReducer from '@/redux/slices/roomSlice'
import advisorWebsocketReducer from '@/redux/slices/advisorWebsocketSlice'
import negotiationWebsocketReducer from '@/redux/slices/negotiationWebsocketSlice'
import studentRoomReducer from '@/redux/slices/studentRoomSlice'
import waitingRoomWebsocketReducer from '@/redux/slices/waitingRoomWebsocketSlice'
import studentDecisionWebsocketReducer from '@/redux/slices/studentDecisionWebsocketSlice'
import adjudicationMessageReducer from '@/redux/slices/adjudicationMessageSlice'
import notificationReducer from '@/redux/slices/notificationSlice'
import timerConfigurationReducer from '@/redux/slices/timerConfigurationSlice'
import timerWebsocketReducer from '@/redux/slices/timerWebsocketSlice'
import negotiationHistoryReducer from '@/redux/slices/negotiationHistorySlice'
import testChatReducer from '@/redux/slices/testChatSlice'
import teamReducer from '@/redux/slices/teamSlice'
import teamChatbotReducer from '@/redux/slices/teamChatbotSlice'
import teamChatReducer from '@/redux/slices/teamChatSlice'
import teamDecisionReducer from '@/redux/slices/teamDecisionSlice'
import mcpServerReducer from '@/redux/slices/mcpServerSlice'
import gameAnalysisReducer from '@/redux/slices/gameAnalysisSlice'
import usageStatsReducer from '@/redux/slices/usageStatsSlice'
import aiPlayerChatReducer from '@/redux/slices/aiPlayerChatSlice'
import researchModeReducer from '@/redux/slices/researchModeSlice'
import aiPlayerTestChatReducer from '@/redux/slices/aiPlayerTestChatSlice'
import remoteMCPReducer from '@/redux/slices/remoteMCPSlice'
import dummyBotReducer from '@/redux/slices/dummyBotSlice'
import charterReducer from '@/features/charter/redux/slices/charterSlice'
import charterPrepWsReducer from '@/features/charter/redux/slices/charterPrepWsSlice'
import charterGroupWsReducer from '@/features/charter/redux/slices/charterGroupWsSlice'
import charterPrepMonitorReducer from '@/features/charter/redux/slices/charterPrepMonitorSlice'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

const store = configureStore({
  reducer: {
    advisor: advisorReducer,
    configuration: configurationReducer,
    chat: chatReducer,
    user: userReducer,
    room: roomReducer,
    advisorWS: advisorWebsocketReducer,
    negotiationWS: negotiationWebsocketReducer,
    decisionsWS: studentDecisionWebsocketReducer,
    studentRoom: studentRoomReducer,
    waitingRoomWS: waitingRoomWebsocketReducer,
    adjudicationMessage: adjudicationMessageReducer,
    notifications: notificationReducer,
    timerConfiguration: timerConfigurationReducer,
    timerWS: timerWebsocketReducer,
    negotiationHistory: negotiationHistoryReducer,
    testChatMessages: testChatReducer,
    team: teamReducer,
    teamChatbot: teamChatbotReducer,
    teamChat: teamChatReducer,
    teamDecision: teamDecisionReducer,
    mcpServer: mcpServerReducer,
    gameAnalysis: gameAnalysisReducer,
    usageStats: usageStatsReducer,
    aiPlayerChat: aiPlayerChatReducer,
    aiPlayerTestChatMessages: aiPlayerTestChatReducer,
    researchMode: researchModeReducer,
    remoteMCP: remoteMCPReducer,
    dummyBot: dummyBotReducer,
    charter: charterReducer,
    charterPrepWS: charterPrepWsReducer,
    charterGroupWS: charterGroupWsReducer,
    charterPrepMonitor: charterPrepMonitorReducer,
  },
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
